module.exports = __webpack_public_path__ + "img/programmer-whiteboard.257318ec.png";